import { toast } from "sonner";

const ToastCard = ({ tone, title, message, onClose }) => {
  const toneStyles =
    tone === "error"
      ? "border-red-200 bg-red-50 text-red-900"
      : "border-emerald-200 bg-emerald-50 text-emerald-900";

  return (
    <div className={`w-full max-w-lg rounded-xl border px-4 py-3 shadow ${toneStyles}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-semibold">{title}</div>
          <div className="mt-1 text-sm leading-snug">{message}</div>
        </div>
        <button
          type="button"
          className="btn btn-ghost btn-xs"
          onClick={onClose}
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export const showPipelineErrorToast = (message) => {
  toast.custom(
    (t) => (
      <ToastCard
        tone="error"
        title="Data mismatch detected"
        message={message}
        onClose={() => toast.dismiss(t)}
      />
    ),
    { duration: 4000 },
  );
};

export const showPipelineSuccessToast = (message) => {
  toast.custom(
    (t) => (
      <ToastCard
        tone="success"
        title="Data check passed"
        message={message}
        onClose={() => toast.dismiss(t)}
      />
    ),
    { duration: 3000 },
  );
};
